import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _styled from '@emotion/styled-base';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.string.includes.js';
import 'core-js/modules/es7.array.includes.js';
import 'core-js/modules/es6.function.name.js';
import 'core-js/modules/es6.array.find-index.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.from.js';
import 'core-js/modules/es6.string.iterator.js';
import 'core-js/modules/es6.object.to-string.js';
import 'core-js/modules/es6.array.iterator.js';
import 'core-js/modules/web.dom.iterable.js';
import React__default, { useState, useRef, useEffect } from 'react';
import { Popover } from '@blueprintjs/core';
import { FormGroup } from '../form-group/form-group.js';
import { InputGroup } from '../input-group/input-group.js';
import { Icon } from '../icon/icon.js';
import { IconOnlyButton } from '../icon-only-button/icon-only-button.js';
import { Search32, Close32 } from '@carbon/icons-react';
import { CellMeasurerCache, AutoSizer, List, CellMeasurer } from 'react-virtualized';
import { intentPrimary, intentPrimaryTranslucentHover, textHeading, border } from '../theme/theme.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ConditionBuilderPopoverMenuSearchFormGroup = /*#__PURE__*/_styled(FormGroup, {
  target: "ec986xb0"
})({
  name: "1porebb",
  styles: "position:relative;z-index:1;padding:0.5rem 0.5rem 0;margin:0;"
});

var ConditionBuilderPopoverMenuList = /*#__PURE__*/_styled("div", {
  target: "ec986xb1"
})("width:", function (_ref) {
  var width = _ref.width;
  return width ? "".concat(width, "px") : "250px";
}, ";min-width:250px;height:", function (_ref2) {
  var filteredMenuItems = _ref2.filteredMenuItems;
  var menuDividersLength = filteredMenuItems.filter(function (item) {
    return item.isHeading;
  }).length;
  var menuItemsLength = filteredMenuItems.length - menuDividersLength;
  var isFirstItemDivider = filteredMenuItems[0].hasOwnProperty("isHeading");
  var menuItemsHeight = "2.25rem * ".concat(menuItemsLength);
  var menuDividersHeight = "3.3125rem * ".concat(menuDividersLength, " ").concat(isFirstItemDivider ? "- 1.0625rem" : "");
  var paddingHeight = "0.5rem";
  return "calc(".concat(menuItemsHeight, " + ").concat(menuDividersHeight, " + ").concat(paddingHeight, ")");
}, ";max-height:", function (_ref3) {
  var hasSearchInput = _ref3.hasSearchInput;
  return hasSearchInput ? "15rem" : "17.5rem";
}, ";padding:0;overflow-x:hidden;overflow-y:auto;");

var ConditionBuilderPopoverMenuItem = /*#__PURE__*/_styled("a", {
  target: "ec986xb2"
})("display:flex;flex-direction:row;align-items:flex-start;gap:0.5rem;padding:0.5rem 0.75rem;color:", function (_ref4) {
  var active = _ref4.active;
  return active ? intentPrimary : "inherit";
}, ";font-weight:", function (_ref5) {
  var active = _ref5.active;
  return active && "600";
}, ";text-decoration:none;user-select:none;&:hover,&:focus{color:", intentPrimary, ";text-decoration:none;background-color:", intentPrimaryTranslucentHover, ";outline:none;}");

var ConditionBuilderPopoverMenuDivider = /*#__PURE__*/_styled("div", {
  target: "ec986xb3"
})("display:flex;flex-direction:row;align-items:flex-start;gap:0.5rem;padding:1rem 0.75rem 0.5rem;padding-top:", function (_ref6) {
  var index = _ref6.index;
  return index === 0 && "0.5rem";
}, ";margin-top:", function (_ref7) {
  var index = _ref7.index;
  return index !== 0 && "0.5rem";
}, ";color:", textHeading, ";font-weight:600;user-select:none;border-top:", function (_ref8) {
  var index = _ref8.index;
  return index !== 0 && "1px solid ".concat(border);
}, ";");

var ConditionBuilderPopoverMenuItemIcon = /*#__PURE__*/_styled(Icon, {
  target: "ec986xb4"
})({
  name: "1ukqcll",
  styles: "margin-top:0.125rem;"
});

var ConditionBuilderPopoverMenuNoResultsIndicator = /*#__PURE__*/_styled("div", {
  target: "ec986xb5"
})("width:", function (_ref9) {
  var width = _ref9.width;
  return width ? "".concat(width, "px") : "250px";
}, ";padding:0.75rem 0.75rem;font-weight:600;");

var ConditionalBuilderPopoverMenu = function ConditionalBuilderPopoverMenu(_ref10) {
  var activeItem = _ref10.activeItem,
      children = _ref10.children,
      disabled = _ref10.disabled,
      isOpen = _ref10.isOpen,
      menuItems = _ref10.menuItems,
      noResultsText = _ref10.noResultsText,
      onOpenChange = _ref10.onOpenChange,
      onSelectItem = _ref10.onSelectItem,
      popoverTargetRef = _ref10.popoverTargetRef,
      popoverWidth = _ref10.popoverWidth,
      searchable = _ref10.searchable,
      _ref10$searchInputCle = _ref10.searchInputClearSearchButtonTooltipText,
      searchInputClearSearchButtonTooltipText = _ref10$searchInputCle === void 0 ? "Clear search" : _ref10$searchInputCle,
      searchInputLabelAndPlaceholderText = _ref10.searchInputLabelAndPlaceholderText;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchQuery = _useState2[0],
      setSearchQuery = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      filteredMenuItems = _useState4[0],
      setFilteredMenuItems = _useState4[1];

  var searchInputRef = useRef(null);
  var menuRef = useRef(null); // Close source popover when click outside

  useEffect(function () {
    var closeSourcePopover = function closeSourcePopover(e) {
      if (isOpen && popoverTargetRef.current !== e.target && !e.target.closest(".vds-condition-builder-popover-menu-search-input") && // Related to hack to fix issue with NumericInput component's ref prop.
      popoverTargetRef.current !== e.target.closest(".vds-condition-builder-numeric-input-wrapper-ref")) {
        onOpenChange && onOpenChange(false);
      }
    };

    document.addEventListener("mouseup", closeSourcePopover);
    return function () {
      document.removeEventListener("mouseup", closeSourcePopover);
    };
  }, [isOpen, popoverTargetRef]);
  useEffect(function () {
    setFilteredMenuItems(menuItems);
  }, [menuItems]);
  useEffect(function () {
    setFilteredMenuItems(menuItems.filter(function (item) {
      return item.isHeading || item.name.toLowerCase().includes(searchQuery.toLowerCase());
    }));
  }, [searchQuery]);
  var cache = new CellMeasurerCache({
    defaultHeight: 36,
    fixedWidth: true
  });
  return /*#__PURE__*/React__default.createElement(Popover, {
    autoFocus: false,
    content: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, searchable && /*#__PURE__*/React__default.createElement(ConditionBuilderPopoverMenuSearchFormGroup, {
      label: searchInputLabelAndPlaceholderText,
      hideLabel: true
    }, /*#__PURE__*/React__default.createElement(InputGroup, {
      className: "vds-condition-builder-popover-menu-search-input",
      leftIcon: /*#__PURE__*/React__default.createElement(Icon, {
        style: {
          pointerEvents: "none"
        }
      }, /*#__PURE__*/React__default.createElement(Search32, null)),
      onChange: function onChange(e) {
        return setSearchQuery(e.target.value);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Escape") {
          onOpenChange && onOpenChange(false);
        }

        if (e.key === "ArrowDown") {
          var _menuRef$current;

          e.preventDefault();
          ((_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.querySelectorAll(".vds-condition-builder-popover-menu-item")[0]).focus();
        }
      },
      placeholder: searchInputLabelAndPlaceholderText,
      ref: searchInputRef,
      rightElement: searchQuery ? /*#__PURE__*/React__default.createElement(IconOnlyButton, {
        className: "vds-condition-builder-search-input-clear-search-button",
        icon: Close32,
        minimal: true,
        onClick: function onClick() {
          var _searchInputRef$curre;

          setSearchQuery("");
          (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus();
        },
        text: searchInputClearSearchButtonTooltipText,
        type: "button"
      }) : undefined,
      tabIndex: 0,
      value: searchQuery
    })), filteredMenuItems.length ? /*#__PURE__*/React__default.createElement(ConditionBuilderPopoverMenuList, {
      className: "vds-condition-builder-popover-menu-list",
      filteredMenuItems: filteredMenuItems,
      ref: menuRef,
      role: "menu",
      hasSearchInput: searchable,
      width: popoverWidth
    }, /*#__PURE__*/React__default.createElement(AutoSizer, null, function (_ref11) {
      var height = _ref11.height,
          width = _ref11.width;
      return /*#__PURE__*/React__default.createElement(List, {
        height: height,
        rowCount: filteredMenuItems.length,
        rowHeight: cache.rowHeight,
        rowRenderer: function rowRenderer(_ref12) {
          var index = _ref12.index,
              key = _ref12.key,
              parent = _ref12.parent,
              style = _ref12.style;
          var IconIncoming = filteredMenuItems[index].icon;
          return /*#__PURE__*/React__default.createElement(CellMeasurer, {
            cache: cache,
            columnIndex: 0,
            key: key,
            parent: parent,
            rowIndex: index
          }, /*#__PURE__*/React__default.createElement("div", {
            style: _objectSpread({}, style)
          }, filteredMenuItems[index].isHeading ? /*#__PURE__*/React__default.createElement(ConditionBuilderPopoverMenuDivider, {
            "aria-level": 2,
            index: index,
            role: "heading"
          }, filteredMenuItems[index].icon && /*#__PURE__*/React__default.createElement(ConditionBuilderPopoverMenuItemIcon, null, /*#__PURE__*/React__default.createElement(IconIncoming, null)), filteredMenuItems[index].name) : /*#__PURE__*/React__default.createElement(ConditionBuilderPopoverMenuItem, {
            active: filteredMenuItems[index].name === activeItem,
            className: "vds-condition-builder-popover-menu-item vds-condition-builder-popover-menu-item-".concat(key)
            /**
             * Using onMouseDown because onClick conflicts
             * with click outside functionality.
             */
            ,
            onMouseDown: function onMouseDown() {
              return onSelectItem(filteredMenuItems[index]);
            },
            onKeyDown: function onKeyDown(e) {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onSelectItem(filteredMenuItems[index]);
                onOpenChange && onOpenChange(false);
              }

              if (e.key === "Escape") {
                onOpenChange && onOpenChange(false);
              }

              if (!e.shiftKey && e.key === "Tab" && key === "".concat(filteredMenuItems.length - 1, "-0") || !searchInputRef.current && e.shiftKey && e.key === "Tab" && key === "0-0") {
                e.preventDefault();
              }

              if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                var _menuRef$current2, _menuRef$current3;

                var tabbableItemsNodeList = (_menuRef$current2 = menuRef.current) === null || _menuRef$current2 === void 0 ? void 0 : _menuRef$current2.querySelectorAll(".vds-condition-builder-popover-menu-item");
                var currentItemNode = (_menuRef$current3 = menuRef.current) === null || _menuRef$current3 === void 0 ? void 0 : _menuRef$current3.querySelector(".vds-condition-builder-popover-menu-item-".concat(key));
                var currentItemNodeIndex = tabbableItemsNodeList && currentItemNode && Array.from(tabbableItemsNodeList).findIndex(function (node) {
                  return node.isEqualNode(currentItemNode);
                }) || 0;

                if (e.key === "ArrowDown" && tabbableItemsNodeList && currentItemNodeIndex < (tabbableItemsNodeList === null || tabbableItemsNodeList === void 0 ? void 0 : tabbableItemsNodeList.length) - 1) {
                  e.preventDefault();
                  tabbableItemsNodeList && tabbableItemsNodeList[currentItemNodeIndex + 1].focus();
                }

                if (e.key === "ArrowUp") {
                  if (currentItemNodeIndex > 0) {
                    e.preventDefault();
                    tabbableItemsNodeList && tabbableItemsNodeList[currentItemNodeIndex - 1].focus();
                  } else {
                    var _searchInputRef$curre2;

                    e.preventDefault();
                    (_searchInputRef$curre2 = searchInputRef.current) === null || _searchInputRef$curre2 === void 0 ? void 0 : _searchInputRef$curre2.focus();
                  }
                }
              }
            },
            role: "menuitem",
            tabIndex: 0
          }, filteredMenuItems[index].icon && /*#__PURE__*/React__default.createElement(ConditionBuilderPopoverMenuItemIcon, null, /*#__PURE__*/React__default.createElement(IconIncoming, null)), filteredMenuItems[index].name)));
        },
        scrollToIndex: filteredMenuItems.findIndex(function (item) {
          return item.name === activeItem;
        }),
        style: {
          padding: "0.25rem 0"
        },
        tabIndex: -1,
        width: width
      });
    })) : /*#__PURE__*/React__default.createElement(ConditionBuilderPopoverMenuNoResultsIndicator, {
      width: popoverWidth
    }, noResultsText)),
    disabled: disabled,
    fill: true,
    isOpen: isOpen,
    minimal: true,
    position: "bottom-left"
  }, children);
};

export { ConditionalBuilderPopoverMenu };
//# sourceMappingURL=condition-builder-popover-menu.js.map
